import React, { useContext, useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
// reactstrap components
import {
    Button,
    Card,
    CardBody,
    CardFooter,
    CardTitle,
    Label,
    FormGroup,
    Form,
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    CustomInput,
    Container,
    Row,
    Col,
    Spinner,
    Modal
} from "reactstrap";

// core components
import LoggedinHeader from "../../components/Headers/LoggedinHeader.js";
import LoggedinNavbar from "../../components/Navbars/LoggedinNavbar.js";
import LoggedinFooter from "../../components/Footers/LoggedinFooter.js";
import { AuthContext } from '../../AuthContext';
import { AxiosContext } from '../../AxiosContext';
import { AnimatePresence, motion } from "framer-motion";
import Auditlog from '../../components/Auditlog';
import HomeSkeleton from "../../skeleton-screens/HomeSkeleton";
import ADModal from '../../components/ADModal';
import Select from 'react-select';
import { Formik } from 'formik';
import * as yup from 'yup';
import LiveStreamModal from '../../components/LiveStreamModal';

function Owner() {
    const navigate = useNavigate();
    const auth = useContext(AuthContext);
    const { authAxios } = useContext(AxiosContext);
    const [isLoading, setIsLoading] = useState(false);
    const [modalMsg, setModalMsg] = useState('');
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [showSpinner, setShowSpinner] = useState(false);
    const [modalLive, setModalLive] = useState(false);

    const [dataLocDetails, setDataLocDetails] = useState([]);
    const [dataCityDropdown, setDataCityDropdown] = useState([]);
    const [valueCityDropdown, setValueCityDropdown] = useState(null);
    const [dataAreaDropdown, setDataAreaDropdown] = useState([]);
    const [valueAreaDropdown, setValueAreaDropdown] = useState(null);
    const [dataTypeDropdown, setDataTypeDropdown] = useState([]);
    const [valueTypeDropdown, setValueTypeDropdown] = useState(null);
    const [liveLocId, setLiveLocId] = useState('');
    const [liveZipCode, setLiveZipCode] = useState('');
    const [role, setRole] = useState('owner');
    const [owned, setOwned] = useState('0');
    const [totalrev, setTotalRev] = useState('0');
    const [totalPmts, setTotalPmts] = useState('0');
    const [totalNoStake, setTotalNoStake] = useState('0');
    const [selectAll, setSelectAll] = useState(false);
    const [dataLocationsSelected, setDataLocationsSelected] = useState([]);
    const [modalLoc, setModalLoc] = useState(false);
    const [locError, setLocError] = useState(false);
    const [ownerreportduration, setownerreportduration] = useState('This month');
    let dataLocFromServer = useRef([]);
    const [logView, setLogView] = useState(false);
    const [userDetails, setUserDetails] = useState([]);
    const [streamUrl, setStreamUrl] = useState(null);

    document.documentElement.classList.remove("nav-open");
    React.useEffect(() => {
        document.body.classList.add("Owner-page");
        return function cleanup() {
            document.body.classList.remove("Owner-page");
        };
    });

    useEffect(() => {
    }, [dataLocDetails]);

    useEffect(() => {
    }, [dataLocationsSelected]);

    const renderSpinner = () => {
        if (showSpinner) {
            return (
                <Modal isOpen={showSpinner} centered={true} className="spinnerModal">
                    <div className="modal-body">
                        <Spinner color="primary">
                            Loading...
                        </Spinner>
                    </div>
                </Modal>

            );
        }
    };
    const showModal = (msg) => {
        setModalMsg(msg);
        setIsModalVisible(!isModalVisible);
    };

    const handleModal = () => showModal('');

    const renderOkButton = () => {
        return (
            <Button
                className="btn-round"
                color="primary"
                type="button"
                onClick={() => handleModal()}
            >
                <span style={{ color: '#0b1011', textTransform: 'none' }}>&nbsp;&nbsp; ok &nbsp;&nbsp;</span>
            </Button>
        );
    };

    const formRef = React.createRef();

    const toggleModalLive = (locid = null) => {
        if (!modalLive) {
            // Modal is opening, start the stream
            setModalLive(true);
            startLiveStream(locid || liveLocId);
        } else {
            // Modal is closing, cleanup
            setStreamUrl(null);
            setModalLive(false);
        }
    };

    const toggleModal = () => {
        setModalLoc(!modalLoc);
    };

    const setvalueCityDropdownFunc = (value) => {
        setValueCityDropdown(value);
    }

    const setvalueAreaDropdownFunc = (value) => {
        setValueAreaDropdown(value);
    }

    const setvalueTypeDropdownFunc = (value) => {
        setValueTypeDropdown(value);
    }

    const clearDropdowns = () => {
        setValueCityDropdown(null);
        setValueAreaDropdown(null);
        setValueTypeDropdown(null);
        setDataLocDetails(dataLocFromServer.current);
    }

    const triggerOwnerLocationAds = (locid) => {
        navigate('/ownerlocad', { state: { locid: locid } });
    };

    const searchLocations = (filter) => {
        let data = dataLocFromServer.current.filter(item => {
            for (let key in filter) {
                if (filter[key] !== null) {
                    if (key === 'area' && item['locid'] != filter[key]) {
                        return false;
                    } else if (key !== 'area' && item[key] != filter[key]) {
                        return false;
                    }
                }
            }
            return true;
        });

        setDataLocDetails(data);
    }

    const renderLiveView = (locid, zipcode) => {
        return (
            <div className="locationItemOwnerLiveViewContent" onClick={() => {
                setLiveLocId(locid);
                setLiveZipCode(zipcode);
                toggleModalLive(locid);
            }}>
                <i className="nc-icon nc-tv-2" />
                <span style={{ textDecoration: 'underline', cursor: "pointer" }}> Live</span>
            </div>
        );
    }

    const startLiveStream = async (locationId) => {
        try {
            console.log("Starting stream for location:", locationId);
            let url = '/startstream';
            let data = {
                data: {
                    id: locationId
                }
            };

            const response = await authAxios.post(url, data);
            let result = response.data;

            if (!result.error) {
                const responseStreamUrl = result.data.stream_url;

                setTimeout(() => {
                    setStreamUrl(responseStreamUrl);
                }, 7000);

            } else {
                console.error("API returned error:", result.error);
            }
        } catch (error) {
            console.error('Error starting live stream:', error);
        }
    };

    useEffect(() => {
        if (streamUrl && liveLocId) {
            let url = '/streamping';
            let data = {
                data: {
                    id: liveLocId
                }
            };

            const interval = setInterval(async () => {
                try {
                    await authAxios.post(url, data);
                    console.log('Stream ping successful for location:', liveLocId);
                } catch (error) {
                    console.error('Stream ping failed:', error);
                }
            }, 10000); // every 10 seconds

            return () => clearInterval(interval); // cleanup on stream stop
        }
    }, [streamUrl, liveLocId]); // Add liveLocId to dependencies

    const renderViewMoreBtn = (locid) => {
        return (
            <div style={{ marginTop: '20px' }} onClick={() => { triggerOwnerLocationAds(locid) }}>
                <span style={{ cursor: "pointer", color: '#344e86', textTransform: 'none' }}>&nbsp;&nbsp; View ads... &nbsp;&nbsp;</span>
            </div>
        );
    };

    const deleteSelection = (locid) => {
        let dataSelected = dataLocationsSelected;
        let data = dataLocDetails;
        let indexDataSelected = dataSelected.findIndex(x => x.locid === locid);
        dataSelected.splice(indexDataSelected, 1);

        setDataLocationsSelected([...dataSelected]);

        let indexData = data.findIndex(x => x.locid === locid);
        if (indexData != -1) {
            data[indexData].checked = false;
            setDataLocDetails([...data]);
        }
    };

    const selectAllFunc = () => {
        setSelectAll(!selectAll);
        let data = dataLocDetails;
        let dataSelected = dataLocationsSelected;

        if (!selectAll) {
            data.map((locData) => {
                locData.checked = true;
                let checkLocId = obj => obj.locid == locData.locid;
                if (!dataSelected.some(checkLocId)) {
                    dataSelected.push(locData);
                }

            });
        }

        if (selectAll) {
            data.map((locData) => {
                locData.checked = false;
                let indexDataSelected = dataSelected.findIndex(x => x.locid === locData.locid);
                if (indexDataSelected != -1) {
                    dataSelected.splice(indexDataSelected, 1);
                }

            });
        }

        setDataLocDetails(data);
        setDataLocationsSelected(dataSelected);
    };

    const onCheckChanged = (id) => {
        const data = dataLocDetails;

        let dataSelected = dataLocationsSelected;


        data.map((locData) => {

            if (locData.locid === id) {
                locData.checked = !locData.checked;
                if (locData.checked) {
                    const checkLocId = obj => obj.locid == locData.locid;
                    if (!dataSelected.some(checkLocId)) {
                        dataSelected.push(locData);
                    }
                }

                if (!locData.checked) {
                    let indexDataSelected = dataSelected.findIndex(x => x.locid === locData.locid);
                    dataSelected.splice(indexDataSelected, 1);
                }
            }


        });

        if (dataSelected.length != 0) {
            setLocError(false);
        }
        setDataLocDetails([...data]);
        setDataLocationsSelected(dataSelected);

    };

    const renderLocations = () => {
        return dataLocDetails.map((locData, index) => {
            return (
                <div className="locationItemOwner" key={index}>
                    <div className="locationItemOwnerCheckbox">
                        <FormGroup check>
                            <Label check>
                                <Input checked={locData.checked} type="checkbox" onChange={() => onCheckChanged(locData.locid)} /><span className="form-check-sign" />
                            </Label>
                        </FormGroup>
                    </div>
                    <div className="locationItemOwnerContent">
                        <div className="locationItemOwnerContentTop">
                            <span>{locData.type}   ({locData.grade})  ({locData.size}&Prime;)  ({locData.orientation})  (img-{locData.priceimg}) (video-{locData.pricevideo})</span>
                        </div>
                        <div className="locationItemOwnerContentTop">
                            <span>{locData.area}, {locData.city}, {locData.zipcode}</span>
                        </div>
                        <div className="locationItemOwnerContentTop">
                            <span>Criteria: {locData.criteria}</span>
                        </div>
                        {renderLocRevenue(locData)}
                        <div className="locationItemOwnerContentTop">
                            <p style={{ paddingTop: '3px' }}>
                                <span style={{ fontSize: 'small', color: '#767676', fontWeight: '900' }}>
                                    Location owner <span style={{ fontSize: 'small', color: '#767676', fontWeight: '300' }}>(time in seconds)</span>:&nbsp;
                                </span>
                            </p>
                        </div>
                        <div className="locationItemOwnerContentTop">
                            <p style={{ paddingTop: '3px' }}>
                                <span style={{ fontSize: 'small', color: '#767676', fontWeight: '500' }}>Next available date if full:&nbsp;
                                    <span style={{ fontSize: 'small', color: '#b33c12', fontWeight: '500' }}>{locData.avldateowner}</span>
                                </span>
                            </p>
                        </div>
                        <div className="locationItemOwnerContentTop">
                            <p style={{ paddingTop: '2px' }}>
                                <span style={{ fontSize: 'small', color: '#767676', fontWeight: '500' }}>Screen time allocated:&nbsp;
                                    <span style={{ fontSize: 'small', color: '#767676', fontWeight: '600' }}>{(locData.blockedsecs)}</span>
                                </span>
                            </p>
                        </div>
                        <div className="locationItemOwnerContentTop">
                            <p style={{ paddingTop: '2px' }}>
                                <span style={{ fontSize: 'small', color: '#767676', fontWeight: '500' }}>Screen time remaining:&nbsp;
                                    <span style={{ fontSize: 'small', color: '#767676', fontWeight: '600' }}>{locData.remindertimeinsecsowner.toFixed(1)}</span>
                                </span>
                            </p>
                        </div>
                        <div className="locationItemOwnerContentTop">
                            <p style={{ paddingTop: '3px' }}>
                                <span style={{ fontSize: 'small', color: '#767676', fontWeight: '900' }}>
                                    Public <span style={{ fontSize: 'small', color: '#767676', fontWeight: '300' }}>(time in seconds)</span>:&nbsp;
                                </span>
                            </p>
                        </div>
                        <div className="locationItemOwnerContentTop">
                            <p style={{ paddingTop: '3px' }}>
                                <span style={{ fontSize: 'small', color: '#767676', fontWeight: '500' }}>Next available date if full:&nbsp;
                                    <span style={{ fontSize: 'small', color: '#b33c12', fontWeight: '500' }}>{locData.avldatepublic}</span>
                                </span>
                            </p>
                        </div>
                        <div className="locationItemOwnerContentTop">
                            <p style={{ paddingTop: '2px' }}>
                                <span style={{ fontSize: 'small', color: '#767676', fontWeight: '500' }}>Screen time allocated:&nbsp;
                                    <span style={{ fontSize: 'small', color: '#767676', fontWeight: '600' }}>{(locData.allowedmins * 60) - locData.blockedsecs}</span>
                                </span>
                            </p>
                        </div>
                        <div className="locationItemOwnerContentTop">
                            <p style={{ paddingTop: '2px' }}>
                                <span style={{ fontSize: 'small', color: '#767676', fontWeight: '500' }}>Screen time remaining:&nbsp;
                                    <span style={{ fontSize: 'small', color: '#767676', fontWeight: '600' }}>{locData.remindertimeinsecspublic.toFixed(1)}</span>
                                </span>
                            </p>
                        </div>
                        <div className="locationItemOwnerContentBottom">
                            <span style={{ fontWeight: "normal", fontSize: 10 }}>{index + 1} </span>
                        </div>
                    </div>
                    <div className="locationItemOwnerLiveView">
                        {renderLiveView(locData.locid, locData.zipcode)}
                        {renderViewMoreBtn(locData.locid)}
                    </div>
                </div>
            );
        });
    }

    const renderLocRevenue = (locData) => {
        if (role == 'superadmin') {
            return (
                <>
                    <div className="locationItemContentTopNoEdit">
                        <span style={{ color: '#767676', fontWeight: '500' }}>Total revenue:&nbsp;&nbsp;</span>
                        <span style={{ color: '#767676', fontWeight: '700' }}>{locData.totaladmin.toFixed(1)}</span>
                    </div>
                </>
            );
        } else {
            return (
                <>
                    <div className="locationItemContentTopNoEdit">
                        <span style={{ color: '#767676', fontWeight: '500' }}>Total revenue:&nbsp;&nbsp;</span>
                        <span style={{ color: '#767676', fontWeight: '700' }}>{locData.totalowner.toFixed(1)}</span>
                    </div>
                </>
            );
        }
    };

    const renderRevStats = () => {
        if (role == 'superadmin') {
            return (
                <>
                    <h4>Total revenue with owner stakes deducted: {parseFloat(totalrev).toFixed(1)}</h4>
                    <h4>Total revenue with no stakes deducted: {parseFloat(totalNoStake).toFixed(1)}</h4>
                    <h4>Total Payments: {parseFloat(totalPmts).toFixed(1)}</h4>
                </>
            );
        } else {
            return (
                <>
                    <h4>Total revenue on all owned locations: {parseFloat(totalrev).toFixed(1)}</h4>
                </>
            );
        }
    }

    const renderSelectedLocations = () => {
        return dataLocationsSelected.map((locData, index) => {
            if (locData.checked) {
                return (
                    <div className="locationItemSelected" key={index}>
                        <div className="locationItemSelectedContent">
                            <div className="locationItemSelectedtTop">
                                <span>{locData.type}   ({locData.size}&Prime;)  ({locData.orientation})  ({locData.price})</span>
                            </div>
                            <div className="locationItemSelectedBottom">
                                <span>{locData.area}, {locData.city}, {locData.zipcode}</span>
                            </div>
                        </div>
                        <div className="locationItemDelete">
                            <div onClick={() => deleteSelection(locData.locid)}><i className="nc-icon nc-simple-remove"></i></div>
                        </div>
                    </div>
                );
            }

        });
    };

    const handleChange = (value) => {
        setownerreportduration(value);
    };

    const renderFormSubmitLocError = () => {
        if (locError) {
            return (
                <div className="input-feedback">Please select location(s)</div>
            );
        }
    };

    const getReport = async () => {
        if (dataLocationsSelected.length == 0) {
            setLocError(true);
        } else {
            try {
                let arr = [];
                dataLocationsSelected.map((locData) => {
                    arr.push(locData.locid);
                });
                let url = '/ownerreports';
                let data = {
                    data: {
                        locs: arr,
                        duration: ownerreportduration
                    }
                };
                setShowSpinner(true);

                const response = await authAxios.post(url, data, { responseType: 'blob' });

                if (response?.data?.error) {
                    throw response.data.error;
                }

                const blob = new Blob([response.data], { type: 'application/pdf' });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = 'adkewl-report.pdf';
                setShowSpinner(false);
                link.click();


            } catch (error) {
                if (typeof error.message === 'undefined') {
                    showModal(error);
                } else {
                    showModal(error.message);
                }
                setShowSpinner(false);
            }
        }

    }


    const fetchData = async () => {
        try {

            setIsLoading(true);
            let url = '/ownerlocs';

            const response = await authAxios.get(url);
            var responseData = [];
            let result = response.data;

            if (result.data) {
                responseData = result.data;
                setUserDetails(responseData.userDetails);
                setDataTypeDropdown(responseData.locTypeDropdown);


                let areaGroups = responseData.locAreaDropdown.reduce((acc, loc) => {
                    if (!acc[loc.value]) {
                        acc[loc.value] = { label: loc.label, value: loc.value };
                    }
                    return acc;
                }, {});

                let allOption = { label: "All", value: 0 };
                let areaDropdown = [allOption, ...Object.values(areaGroups)];

                setDataAreaDropdown(areaDropdown);

                setDataCityDropdown(responseData.locCityDropdown);
                dataLocFromServer.current = responseData.locations;

                setDataLocDetails(responseData.locations);
                setRole(responseData.role);
                setOwned(responseData.numowned);
                setTotalRev(responseData.totalrevenue);
                if (responseData.role == 'superadmin') {
                    setTotalNoStake(responseData.totalwithoutstake);
                    setTotalPmts(responseData.totalpayments);
                }

            } else {
                throw "Server error. Unable to fetch data";
            }

            setIsLoading(false);
        } catch (error) {
            showModal("Server Error. Please refresh or relogin");
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <>
            <LoggedinHeader />
            <LoggedinNavbar />
            <AnimatePresence>
                <div className="main">
                    <div className="text-center">
                        {isLoading && (
                            <Container>
                                <HomeSkeleton exit={{ opacity: 0 }} />
                            </Container>
                        )}
                        <Container>
                            {!isLoading && (
                                <Row>
                                    <Col className="ml-auto mr-auto">
                                        <div className="AdminHomeContainer">
                                            <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "flex-start", flexDirection: "column" }}>
                                                <h4>Number of Locations Owned: {owned}</h4>
                                                {renderRevStats()}
                                            </div>
                                            <div className="AdminHomeFilterDropdowns">
                                                <Select
                                                    className="reactSelectDropdown"
                                                    classNamePrefix="reactSelectDropdownData"
                                                    value={valueCityDropdown}
                                                    onChange={setvalueCityDropdownFunc}
                                                    options={dataCityDropdown}
                                                    isSearchable={true}
                                                    placeholder="City"
                                                />
                                                <Select
                                                    className="reactSelectDropdown"
                                                    classNamePrefix="reactSelectDropdownData"
                                                    value={valueAreaDropdown}
                                                    onChange={setvalueAreaDropdownFunc}
                                                    options={dataAreaDropdown}
                                                    isSearchable={true}
                                                    placeholder="Area"
                                                />
                                                <Select
                                                    className="reactSelectDropdown"
                                                    classNamePrefix="reactSelectDropdownData"
                                                    value={valueTypeDropdown}
                                                    onChange={setvalueTypeDropdownFunc}
                                                    options={dataTypeDropdown}
                                                    isSearchable={true}
                                                    placeholder="Type"
                                                />
                                            </div>
                                            <div className="AdminHomeFilterButtons">
                                                <div style={{ width: "20%" }}>
                                                    <Button
                                                        className="btn-round btn-createad"
                                                        color="primary"
                                                        onClick={() => searchLocations({
                                                            "city": valueCityDropdown ? valueCityDropdown.value : null,
                                                            "area": valueAreaDropdown ? valueAreaDropdown.value : null,
                                                            "type": valueTypeDropdown ? valueTypeDropdown.value : null
                                                        })}
                                                    >
                                                        <span style={{ color: '#0b1011', textTransform: 'none' }}>&nbsp;Filter&nbsp;</span>
                                                    </Button>
                                                </div>
                                                <div style={{ width: "20%", marginLeft: "10px" }}>
                                                    <Button
                                                        className="btn-round btn-createad"
                                                        color="primary"
                                                        onClick={() => clearDropdowns()}
                                                    >
                                                        <span style={{ color: '#0b1011', textTransform: 'none' }}>&nbsp;Clear&nbsp;</span>
                                                    </Button>
                                                </div>

                                            </div>
                                            <div className="AdminHomeRadioButtons">
                                                <div className="OwnerRadioButtons">
                                                    <FormGroup check>
                                                        <Label check onClick={() => handleChange("This month")}>
                                                            <Input
                                                                className="OwnerRadioButtonsInput"
                                                                type="radio"
                                                                name="ownerreportduration"
                                                                value="This month"
                                                                checked={ownerreportduration === "This month" ? true : false}
                                                                onChange={(e) => { }}
                                                            />

                                                            This month
                                                        </Label>
                                                    </FormGroup>
                                                </div>
                                                <div className="OwnerRadioButtons">
                                                    <FormGroup check>
                                                        <Label check onClick={() => handleChange("Last month")}>
                                                            <Input
                                                                className="OwnerRadioButtonsInput"
                                                                type="radio"
                                                                name="ownerreportduration"
                                                                value="Last month"
                                                                checked={ownerreportduration === "Last month" ? true : false}
                                                                onChange={(e) => { }}
                                                            />

                                                            Last month
                                                        </Label>
                                                    </FormGroup>
                                                </div>
                                                <div className="OwnerRadioButtons">
                                                    <FormGroup check>
                                                        <Label check onClick={() => handleChange("Last 3 months")}>
                                                            <Input
                                                                className="OwnerRadioButtonsInput"
                                                                type="radio"
                                                                name="ownerreportduration"
                                                                value="Last 3 months"
                                                                checked={ownerreportduration === "Last 3 months" ? true : false}
                                                                onChange={(e) => { }}
                                                            />

                                                            Last 3 months
                                                        </Label>
                                                    </FormGroup>
                                                </div>
                                                <div className="OwnerRadioButtons">
                                                    <FormGroup check>
                                                        <Label check onClick={() => handleChange("Last 6 months")}>
                                                            <Input
                                                                className="OwnerRadioButtonsInput"
                                                                type="radio"
                                                                name="ownerreportduration"
                                                                value="Last 6 months"
                                                                checked={ownerreportduration === "Last 6 months" ? true : false}
                                                                onChange={(e) => { }}
                                                            />

                                                            Last 6 months
                                                        </Label>
                                                    </FormGroup>
                                                </div>
                                                <div className="OwnerRadioButtons">
                                                    <FormGroup check>
                                                        <Label check onClick={() => handleChange("Last 1 year")}>
                                                            <Input
                                                                className="OwnerRadioButtonsInput"
                                                                type="radio"
                                                                name="ownerreportduration"
                                                                value="Last 1 year"
                                                                checked={ownerreportduration === "Last 1 year" ? true : false}
                                                                onChange={(e) => { }}
                                                            />

                                                            Last 1 year
                                                        </Label>
                                                    </FormGroup>
                                                </div>
                                                <div className="OwnerRadioButtons">
                                                    <Button
                                                        className="btn-round btn-createad"
                                                        color="primary"
                                                        onClick={() => getReport()}
                                                    >
                                                        <span style={{ color: '#0b1011', textTransform: 'none' }}>&nbsp;Get report&nbsp;</span>
                                                    </Button>
                                                </div>
                                            </div>
                                            <div className="logViewLocOwner" >
                                                <div onClick={() => setLogView(true)}>
                                                    <span style={{ textDecorationLine: "underline", fontWeight: "bold", color: "#4d79ff", cursor: 'pointer' }}>View logs</span>
                                                </div>
                                                <Auditlog
                                                    isVisible={logView}
                                                    userDetails={userDetails}
                                                    adDetails={null}
                                                    areaDropdown={dataAreaDropdown}
                                                    setShowSpinner={setShowSpinner}
                                                    setLogView={setLogView}
                                                    showModal={showModal}
                                                    authAxios={authAxios}
                                                    fromScreen={"locowner"}
                                                />
                                            </div>
                                            {renderFormSubmitLocError()}
                                            <div className="AddetailsLocationContainer">
                                                <div className="AddetailsLocationAllModal">
                                                    <div className="AddetailsLocationSelectall">
                                                        <FormGroup check>
                                                            <Label check>
                                                                <Input checked={selectAll} type="checkbox" onChange={() => selectAllFunc()} /><span className="form-check-sign" />
                                                                <span style={{ color: '#0b1011' }}>Select All (for report)</span>
                                                            </Label>
                                                        </FormGroup>

                                                    </div>
                                                    <div className="AddetailsLocationsModal" onClick={() => setModalLoc(true)}>
                                                        <span style={{ textDecorationLine: "underline", fontWeight: "bold", color: "#4d79ff", cursor: 'pointer' }}>View or remove selection (for report)</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="AdminAdDetails">
                                                {renderLocations()}
                                            </div>

                                        </div>
                                    </Col>
                                </Row>
                            )}
                        </Container>
                    </div>
                    <Modal isOpen={modalLoc} centered={true} toggle={toggleModal}>
                        <div className="modal-header">
                            <button
                                aria-label="Close"
                                className="close"
                                type="button"
                                onClick={toggleModal}
                            >
                                <span aria-hidden={true}>×</span>
                            </button>
                            <h5
                                className="modal-title text-center"
                                id="exampleModalLabel"
                            >
                                Selected locations
                            </h5>
                        </div>
                        <div className="modal-body">
                            {renderSelectedLocations()}
                        </div>
                    </Modal>
                    <Modal isOpen={modalLive} centered={true} toggle={toggleModalLive} size="xl">
                        <div className="modal-header">
                            <button
                                aria-label="Close"
                                className="close"
                                type="button"
                                onClick={toggleModalLive}
                            >
                                <span aria-hidden={true}>×</span>
                            </button>
                            <h5
                                className="modal-title text-center"
                                id="exampleModalLabel"
                            >
                                Live feed - if distorted feed is observed it is just a network problem but it runs fine on actual displays.
                            </h5>
                        </div>
                        <div className="modal-body">
                            <div className="adDetailsContainer">
                                <div className="adDetailsLive">
                                    <LiveStreamModal streamUrl={streamUrl} />
                                </div>
                            </div>

                        </div>
                    </Modal>
                    <ADModal
                        isVisible={isModalVisible}
                        msg={modalMsg}
                        children={renderOkButton()}
                    />
                    {renderSpinner()}

                </div>
            </AnimatePresence>
            <LoggedinFooter />

        </>
    );
}

export default Owner;
